export const SUPPORT_SESSION_KEY = 'ttic-support-session';
let transitioning = false;

export const readSupportSession = () => {
  try {
    const session = JSON.parse(sessionStorage.getItem(SUPPORT_SESSION_KEY));
    return session?.token && session.id && Number.isFinite(Date.parse(session.expiresAt)) ? session : null;
  } catch { return null; }
};
export const saveSupportSession = session => sessionStorage.setItem(SUPPORT_SESSION_KEY, JSON.stringify(session));
export const clearSupportSession = () => sessionStorage.removeItem(SUPPORT_SESSION_KEY);
export const supportReturnPath = session => session?.targetRole === 'manager'
  ? '/admin/team' : `/admin/users?user=${encodeURIComponent(session?.targetUserId || '')}`;
export const beginSupportTransition = () => { transitioning = true; };
export const isSupportTransitioning = () => transitioning;
// Never fall back to the owner's identity while a target page is still open,
// even if the support token has expired. The 401 handler returns to the owner.
export const getActiveToken = () => readSupportSession()?.token || localStorage.getItem('token');
